import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-34925410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-topbar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PT Sinar AlumSarana", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-v" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "my-text-marquee" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Calendar", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Profile", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cog" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Settings", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

import {ref, computed, onMounted, onBeforeUnmount} from 'vue'
// @ts-ignore
import {useLayout} from '@/layout/composables/layout'
import {useRouter} from 'vue-router'
import {useMQTT} from "mqtt-vue-hook"
import {SubscribeOptions} from "mqtt-vue-hook/dist/base-hook"
import { Vue3Marquee } from 'vue3-marquee'

interface Res {
  IsDowntime: boolean,
  Message: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTopbar',
  setup(__props) {

const {layoutConfig, onMenuToggle} = useLayout()

const outsideClickListener = ref(null)
const topbarMenuActive = ref(false)
const router = useRouter()

const res = ref<Res>({
  IsDowntime: false,
  Message: ''
})

onMounted(() => {
  bindOutsideClickListener()

  const mqttHook = useMQTT()
  mqttHook.subscribe([
    "sas/tangerang/web/notif/downtime/7",
  ], 1, { properties: { userProperties: { } }, } as SubscribeOptions, () => {
    console.log('subscribed! ' + "sas/tangerang/web/notif/downtime/7")
  })

  mqttHook.registerEvent("sas/tangerang/web/notif/downtime/7", (topic: string, message: string) => {
    res.value = JSON.parse(message.toString()) as Res
  })
})

onBeforeUnmount(() => {
  unbindOutsideClickListener()
})

const logoUrl = computed(() => {
  return `layout/images/${layoutConfig.darkTheme.value ? 'logo-white' : 'logo-dark'}.svg`
})

const onTopBarMenuButton = () => {
  topbarMenuActive.value = !topbarMenuActive.value
}
const onSettingsClick = () => {
  topbarMenuActive.value = false
  router.push('/documentation')
}
const topbarMenuClasses = computed(() => {
  return {
    'layout-topbar-menu-mobile-active': topbarMenuActive.value
  }
})

const bindOutsideClickListener = () => {
  if (!outsideClickListener.value) {
    // @ts-ignore
    outsideClickListener.value = (event) => {
      if (isOutsideClicked(event)) {
        topbarMenuActive.value = false
      }
    }
    // @ts-ignore
    document.addEventListener('click', outsideClickListener.value)
  }
}
const unbindOutsideClickListener = () => {
  if (outsideClickListener.value) {
    // @ts-ignore
    document.removeEventListener('click', outsideClickListener)
    outsideClickListener.value = null
  }
}
// @ts-ignore
const isOutsideClicked = (event) => {
  if (!topbarMenuActive.value) return

  const sidebarEl = document.querySelector('.layout-topbar-menu')
  const topbarEl = document.querySelector('.layout-topbar-menu-button')

  // @ts-ignore
  return !(sidebarEl.isSameNode(event.target) || sidebarEl.contains(event.target) || topbarEl.isSameNode(event.target) || topbarEl.contains(event.target))
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "layout-topbar-logo"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _createElementVNode("button", {
      class: "p-link layout-menu-button layout-topbar-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onMenuToggle)()))
    }, _hoisted_5),
    _createElementVNode("button", {
      class: "p-link layout-topbar-menu-button layout-topbar-button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (onTopBarMenuButton()))
    }, _hoisted_7),
    (res.value.IsDowntime)
      ? (_openBlock(), _createBlock(_unref(Vue3Marquee), {
          key: 0,
          class: "my-marquee",
          duration: "10"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_8, _toDisplayString(res.value.Message), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["layout-topbar-menu", topbarMenuClasses.value])
    }, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (onTopBarMenuButton())),
        class: "p-link layout-topbar-button"
      }, _hoisted_11),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (onTopBarMenuButton())),
        class: "p-link layout-topbar-button"
      }, _hoisted_14),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (onSettingsClick())),
        class: "p-link layout-topbar-button"
      }, _hoisted_17)
    ], 2)
  ]))
}
}

})